import dayjs from 'dayjs';

export const getQBRTimePeriod = () => {
  const today = dayjs();

  // Assumes Q1 is Jan-Mar, Q2 is Apr-Jun, Q3 is Jul-Sep, Q4 is Oct-Dec. Count from 0
  const currentQuarter = Math.floor(today.month() / 3);

  // Review is for previous quarter, not current
  const previousQuarter = currentQuarter - 1;

  switch (previousQuarter) {
    case -1:
      return `October - December ${today.subtract(1, 'year').year()}`;
    case 0:
      return `January - March ${today.year()}`;
    case 1:
      return `April - June ${today.year()}`;
    case 2:
      return `July - September ${today.year()}`;
    case 3:
      // Not actually possible for previous quarter
      return `October - December ${today.year()}`;
    default:
      return '-';
  }
};
